import type { ReactNode } from 'react';

import { SidebarNavItem } from '@ipen/components';
import { Link, useLocation } from 'react-router-dom';

type Props = {
  className?: string;
  href: string;
  icon?: ReactNode;
  title?: string;
};

export const BackstageCatalogNavigationItem = ({
  className,
  href,
  icon,
  title = 'Data Catalog',
}: Props) => {
  const location = useLocation();

  const isCommunity =
    new URLSearchParams(location.search).get('filters[kind]') === 'group';

  const isActive =
    !isCommunity
    && (location.pathname === href || location.pathname.startsWith(`${href}/`));

  return (
    <SidebarNavItem
      active={isActive}
      className={className}
      component={Link}
      icon={icon}
      label={title}
      to={href}
    />
  );
};
